module.exports = __webpack_public_path__ + "img/bikers.7032587f.svg";